var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVolume2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.656334232 0.000111240429 4.644 0.000111240429 4.644 12.0000426 0.656334232 12.0000426"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-762.000000, -2375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/volume2",
    transform: "translate(762.000000, 2375.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0488,11.8066 C1.6958,12.1136 1.1518,12.0456 0.8638,11.6706 C0.5768,11.2936 0.6078,10.7136 0.9608,10.4066 C2.1778,9.3816 2.9458,7.7766 2.9458,6.0006 C2.9458,4.2236 2.1778,2.6526 0.9608,1.5946 C0.6078,1.2866 0.5438,0.7056 0.8638,0.3306 C1.1518,-0.0464 1.6968,-0.1134 2.0488,0.1946 C3.6498,1.5606 4.6438,3.6786 4.6438,6.0016 C4.6748,8.3556 3.6498,10.4406 2.0488,11.8066",
    id: "Fill-1",
    fill: "#858199",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8569,12.3032 C15.5059,12.6152 14.9659,12.5462 14.6809,12.1642 L14.6179,12.0952 C14.3319,11.7472 14.3959,11.1912 14.7439,10.9132 C15.2839,10.4962 15.6019,9.8012 15.6019,9.0012 C15.6019,8.2702 15.2839,7.6102 14.8079,7.1582 C14.4259,6.8102 14.3629,6.2532 14.6809,5.8362 C14.9659,5.4532 15.5079,5.3842 15.8889,5.6982 C16.7789,6.4622 17.3189,7.6452 17.3189,9.0012 C17.3189,10.3552 16.7469,11.5382 15.8569,12.3032",
    id: "Fill-4",
    fill: "#858199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,16.5014 C13,17.7374 11.458,18.4384 10.401,17.6954 L4.364,13.3694 L1.412,13.3694 C0.663,13.3694 0.002,12.7934 0.002,12.0514 L0,5.9504 C0,5.2504 0.616,4.6314 1.41,4.6314 L4.362,4.6314 L10.399,0.3044 C11.456,-0.4376 12.998,0.2624 12.998,1.4984 L13,16.5014 Z",
    id: "Fill-6",
    fill: "#858199"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume2);
export default __webpack_public_path__ + "static/media/iconVolume2.49120b87.svg";
export { ForwardRef as ReactComponent };